module.exports = __webpack_public_path__ + "static/media/blck28.9b185f5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/black/blck28.jpg
// module id = 492
// module chunks = 0